export default "__VITE_ASSET__IBru0YaDkDIujHpESjTY9w__"